/*
 * @Description: 注入全局的方法
 * @version:
 * @Author: knight
 * @Date: 2022-01-17 17:04:13
 * @LastEditors: knight
 * @LastEditTime: 2022-02-09 14:03:02
 */
import { get, post, del, put, patch } from '@/api/index';
import util from '@/helper/index.js';
import { Toast } from 'mint-ui';
import { formatDate, formatPrice } from '../helper/index';

import FingerprintJS from '@fingerprintjs/fingerprintjs';
const moment = require('moment');
const _ = require('lodash');

const plugins = {
  // 注册
  install(Vue) {
    Vue.prototype.$get = get;
    Vue.prototype.$post = post;
    Vue.prototype.$del = del;
    Vue.prototype.$put = put;
    Vue.prototype.$patch = patch;
    Vue.prototype.$util = util;
    Vue.prototype.$moment = moment;
    Vue.prototype.$_ = _;
    Vue.prototype.$toast = Toast;
    Vue.prototype.$formatPrice = formatPrice;
    Vue.prototype.$formatDate = formatDate;

    Vue.prototype.$miniProImagesPath = src =>
      `https://xlhz.oss-cn-hangzhou.aliyuncs.com/miniProgram/images/${src}`;
    (async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      Vue.prototype.$fingerprint = result.visitorId;
    })();

  },
};
export default plugins;
